import { render, staticRenderFns } from "./MasterCodeTableInfo.vue?vue&type=template&id=00839b17&"
import script from "./MasterCodeTableInfo.vue?vue&type=script&lang=ts&"
export * from "./MasterCodeTableInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports